import React, { useEffect } from 'react';
import './RssItemPage.css';
import LoadingCmp from '../../components/common/LoadingCmp';
import { useParams } from 'react-router-dom';
import { useItem } from '../../hooks/useQueries';
import { useAppContext } from '../../providers/AppContext';
import SEOCmp from '../../components/common/SEOCmp';

export default function RssItemPage() {
  const { innerWidth: width, innerHeight: height } = window;
  const { itemId } = useParams();
  const { setPageTitle, setIsNavMinimized } = useAppContext();

  const { data: result } = useItem(Number(itemId));

  useEffect(() => {
    setIsNavMinimized(true);
    return () => {
      setIsNavMinimized(false);
    };
  }, [setIsNavMinimized]);

  useEffect(() => {
    if (result?.result?.title) {
      setPageTitle(result.result.title);
    }
  }, [result, setPageTitle]);

  const itemData = result?.result;

  if (!itemData || Object.keys(itemData).length === 0) {
    return <LoadingCmp />;
  }

  const itemUrl = itemData.url;
  const itemTitle = itemData.title;
  const hasFrameOptions = itemData.hasFrameOptions;

  const seoProps = {
    title: itemTitle,
    description: itemData.itemDescription,
    image: itemData.itemMediaUrl,
    url: window.location.href,
    type: 'article',
    author: itemData.sitetitle,
    publishedDate: itemData.timesAgoDate,
  };

  if (hasFrameOptions) {
    return (
      <div id="items-container">
        <SEOCmp {...seoProps} />
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <a
            href={itemUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Yeni sayfada açmak için tıklayınız.
          </a>
        </div>
      </div>
    );
  }

  return (
    <div id="items-container">
      <SEOCmp {...seoProps} />
      <iframe
        title={itemTitle}
        src={itemUrl}
        id="itemContent"
        width={width}
        height={height - 65}
        frameBorder="0"
        allow="fullscreen"
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
}
